import Contact from "../../src/components/Home/Contact";
import BreadCrumb from "../../src/components/Shared/BreadCrumb";

import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import BlogItem from "../../src/components/Home/BlogItem";
import server from "../../src/api/server";
import { FormattedMessage, useIntl } from "react-intl";
import { NextSeo } from "next-seo";
const BlogsPage = ({
  blogsData,
  error,
  blogCategoriesData,
  socialsData,
  breadBackground,
  contactUsBack,
  metaDataSections,
}) => {
  const blogsMeta = metaDataSections?.find((item) => item?.slug === "blogs");

  error && console.log(JSON.parse(error));
  const { locale, formatMessage } = useIntl();
  const renderBlogCategories = blogCategoriesData?.map((category, index) => {
    return (
      <li key={category.id}>
        <Link href={`/blog/categories/${category.id}`}>
          <a aria-label="blog categories">
            <span>.0{index + 1}</span>
            {category?.title?.[locale]}
          </a>
        </Link>
      </li>
    );
  });

  const renderBlogs = blogsData?.map((blog, index) => {
    return (
      <Col xl={6} lg={6} md={6} xs={12} key={blog.id}>
        <BlogItem blog={{ ...blog, count: index + 1 }} />
      </Col>
    );
  });

  return (
    <>
      <NextSeo
        title={
          blogsMeta?.name[locale] || formatMessage({ id: blogsMeta?.slug })
        }
        description={
          blogsMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="blogs-page">
        <BreadCrumb
          title={<FormattedMessage id="blog" />}
          pageTitle={<FormattedMessage id="blog" />}
          breadBackground={breadBackground}
        />
        <div className="blogs-body">
          <Container>
            <Row>
              <Col xl={9} lg={9} md={12} xs={12}>
                <Row>{renderBlogs}</Row>
              </Col>
              <Col xl={3} lg={3} md={12} xs={12}>
                <div className="sidebar">
                  <div className="widget">
                    <h4>
                      <FormattedMessage id="blogsCategories" />
                    </h4>
                    <div className="service-list">
                      <ul>{renderBlogCategories}</ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Contact
          {...{
            socialsData,
            contactUsBack,
          }}
        />
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const blogResponse = await server.get("/blogs");
    const blogCategoriesResponse = await server.get("/categories");
    const socialsResponse = await server.get("/settings/socials");
    const metaDataResponse = await server.get("/pages/metaData");
    let breadBack, contactUsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "contactUs"
      )?.image;
    } catch (err) {
      console.log(err);
    }

    return {
      revalidate: 1,
      props: {
        blogsData: blogResponse.data.data.blogs,
        blogCategoriesData: blogCategoriesResponse.data.data.categories,
        socialsData: socialsResponse?.data?.data?.socials,
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : "",
        contactUsBack: contactUsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
          : "",
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default BlogsPage;
